import type { PageLoad } from './$types';
import { locales, type Locale } from '$lib/paraglide/runtime';
import { wikiHref } from '$lib/features/wiki/logic/wiki-index';

export const load: PageLoad = () => ({
	// Strona główna ma odpowiednik w każdym języku — hrefy dla switchera.
	translations: Object.fromEntries(
		(locales as readonly Locale[]).map((locale) => [locale, wikiHref(locale)])
	) as Record<Locale, string>
});
